import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Server } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const RelaySourceNode = ({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data.label || 'Hybrid Source'}
        icon={Server}
        colorClass=""
        bgClass="bg-gradient-to-br from-blue-500 to-blue-700"
        selected={selected}
        executionStatus={data?.executionStatus}
        isRunning={data?.executionStatus === 'Running'}
        isSource={true}
        isTarget={true}
    />
);

export default memo(RelaySourceNode);
